function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { safeSelect } from '@sie/web-common-utils';
/**
 * This component will honor a maxHeight until the contained content begins to leave
 * the top of the screen.
 */

var RestrictUntilAboveContainer = /*#__PURE__*/function (_PureComponent) {
  _inherits(RestrictUntilAboveContainer, _PureComponent);

  var _super = _createSuper(RestrictUntilAboveContainer);

  function RestrictUntilAboveContainer(props) {
    var _this;

    _classCallCheck(this, RestrictUntilAboveContainer);

    _this = _super.call(this, props);
    _this._root = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(RestrictUntilAboveContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (ResizeObserver) {
        this.resizeObserver = new ResizeObserver(function () {
          var rootEl = _this2._root.current;
          var containerRef = _this2.props.containerRef;
          var containerEl = safeSelect(containerRef, 'current');
          if (!rootEl || !containerEl) return;

          var _containerEl$getBound = containerEl.getBoundingClientRect(),
              containerY = _containerEl$getBound.y;

          var parent = rootEl.parentNode;

          var _rootEl$getBoundingCl = rootEl.getBoundingClientRect(),
              height = _rootEl$getBoundingCl.height,
              y = _rootEl$getBoundingCl.y;

          var isOffScreen = y < containerY;
          var shouldRestoreMaxHeight = y > containerY + 5;

          if (isOffScreen) {
            parent.style.maxHeight = "".concat(height, "px");
          } else if (shouldRestoreMaxHeight) {
            parent.style.maxHeight = null;
          }
        }).observe(this._root.current);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        ref: this._root
      }, children));
    }
  }]);

  return RestrictUntilAboveContainer;
}(PureComponent);

RestrictUntilAboveContainer.defaultProps = {
  containerRef: null,
  className: '',
  children: null
};
RestrictUntilAboveContainer.propTypes = {
  containerRef: PropTypes.shape({
    current: PropTypes.element
  }),
  className: PropTypes.string,
  children: PropTypes.node
};
export default RestrictUntilAboveContainer;